import { toast } from "sonner";

/**
 * Robust copy to clipboard function with fallback for non-secure contexts.
 */
export const copyToClipboard = async (text: string, successMessage: string = "Copied!") => {
  if (!text) return false;
  
  // Normalize line endings
  const normalizedText = text.replace(/\r\n/g, '\n');

  try {
    // Priority 1: Modern Clipboard API
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(normalizedText);
      toast.success(successMessage);
      return true;
    }
  } catch (err) {
    console.warn("Modern clipboard API failed, trying legacy fallback...", err);
  }

  // Priority 2: Legacy Fallback with hidden textarea
  try {
    const textArea = document.createElement("textarea");
    textArea.value = normalizedText;
    
    // Crucial: Must be part of the DOM and not hidden with display:none
    textArea.setAttribute('readonly', ''); // Prevent keyboard popup on mobile
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    
    const range = document.createRange();
    range.selectNodeContents(textArea);
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    
    textArea.select();
    textArea.setSelectionRange(0, normalizedText.length); // For iOS
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    selection?.removeAllRanges();
    
    if (successful) {
      toast.success(successMessage);
      return true;
    }
  } catch (err) {
    console.error("Legacy copy fallback failed", err);
  }

  toast.error("Copy failed - please select and copy manually");
  return false;
};
